<template>
    <modal-wrapper modalClass="modal--form" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header">
            <h1>{{$t('modals.edit_trajectory.title')}}</h1>
        </div>

        <trajectory-form
            v-if="trajectory && trajectory.id"
            :trajectory="trajectory"
            :wrapperClass="['modal__content']"
            @saved="onTrajectoryUpdated">

            <div class="modal__footer" slot="buttons" slot-scope="{ isSaveDisabled }">
                <div class="actions">
                    <button class="actions__action--save pull-right" type="submit" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('modals.edit_trajectory.update')}}</button>
                    <button class="actions__action--cancel" type="button" @click="$modal.hide(name)">{{$t('modals.common.cancel')}}</button>
                </div>
            </div>
        </trajectory-form>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import ModalWrapper from '@/components/general/ModalWrapper';

    import TrajectoryForm from '@/components/forms/dashboard/TrajectoryForm';

    import { Trajectory } from '@/models';

    import { GET_TRAJECTORY } from '@/store/modules/trajectory';
    import { LOAD_TRAJECTORY_RESOURCES } from '@/store/modules/trajectory-resources';

    @Component({
        components: {
            TrajectoryForm
        }
    })
    export default class TrajectoryEditModal extends Vue {
        name = 'trajectory-edit-modal';

        trajectory = new Trajectory();

        beforeOpen(event) {
            this.$store.dispatch(LOAD_TRAJECTORY_RESOURCES);
            // Initialize the trajectory with passed values;
            this.trajectory.fill(event.params.trajectory);
        }

        onTrajectoryUpdated(trajectory) {
            this.$notify.success(this.$t('notify.trajectory.update_success'));
            this.$store.dispatch(GET_TRAJECTORY, { id: trajectory.id});
            this.$modal.hide(this.name);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modals/dashboard/TrajectoryEditModal.vue